/*! Oruga v0.10.4 | MIT License | github.com/oruga-ui/oruga */
import { toValue } from "vue";
import { c as getOption } from "./config-CMiuMs1N.mjs";
function useTeleportDefault() {
  const option = getOption("teleportTarget", "body");
  return toValue(option);
}
export {
  useTeleportDefault as u
};
//# sourceMappingURL=useConfig-CntSTIWZ.mjs.map
